"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFunction = void 0;
/**
 * Extract the function signature from a composite function.
 *
 * @note does not work with function overloads.
 */
function extractFunction(fn) {
    return fn;
}
exports.extractFunction = extractFunction;
//# sourceMappingURL=extract_function.js.map